/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionStatusResponse
 */
export interface InspectionStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionStatusResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionStatusResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionStatusResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the InspectionStatusResponse interface.
 */
export function instanceOfInspectionStatusResponse(value: object): value is InspectionStatusResponse {
    return true;
}

export function InspectionStatusResponseFromJSON(json: any): InspectionStatusResponse {
    return InspectionStatusResponseFromJSONTyped(json, false);
}

export function InspectionStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function InspectionStatusResponseToJSON(json: any): InspectionStatusResponse {
    return InspectionStatusResponseToJSONTyped(json, false);
}

export function InspectionStatusResponseToJSONTyped(value?: InspectionStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

